<app-button-outline
  [action]="approveAction"
  [isHighlight]="true"
  [typeOfButton]="ButtonOutline[1]"
  [matTooltip]="
    stateManagerProjectService.is3dUpdateNeeded
      ? ('Notifications.UPDATE_3DMODEL_APPROVE' | translate)
      : ('Notifications.CHECK_SLICES_APPROVE' | translate)
  "
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="
    checkPercentsOfViewed() && !stateManagerProjectService.is3dUpdateNeeded
  "
></app-button-outline>
<div class="spinner-Overlay" *ngIf="displaySpinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>